import React from 'react';
import { cn } from '../../lib/utils';
interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  noPadding?: boolean;
}
export function Card({
  className,
  noPadding = false,
  children,
  ...props
}: CardProps) {
  return <div className={cn('rounded-xl border border-slate-200 bg-white text-slate-900 shadow-sm', className)} {...props} data-id="element-102">
      <div className={cn(noPadding ? '' : 'p-6')} data-id="element-103">{children}</div>
    </div>;
}
export function CardHeader({
  className,
  children,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('flex flex-col space-y-1.5 p-6 pb-0', className)} {...props} data-id="element-104">
      {children}
    </div>;
}
export function CardTitle({
  className,
  children,
  ...props
}: React.HTMLAttributes<HTMLHeadingElement>) {
  return <h3 className={cn('font-semibold leading-none tracking-tight', className)} {...props} data-id="element-105">
      {children}
    </h3>;
}
export function CardContent({
  className,
  children,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('p-6 pt-0', className)} {...props} data-id="element-106">
      {children}
    </div>;
}